import {pageData} from '../constants/pagedata';

export const PagePicker=function(props:{pageClick:(page: string) => void,pageSelected:string,showList:string[]}){
	const pages=props.showList.map((page)=>{
		let thumbId=page+'-teachers';
		let myClassName=page===props.pageSelected?'teachers-pagepicker-item-selected':'teachers-pagepicker-item';
		return (
			<div key={page} onClick={()=>{props.pageClick(page)}} className={myClassName}>
				<div className='teachers-pagepicker-item-im' id={thumbId}></div>
				<p className='teachers-pagepicker-item-txt'>{pageData[page].label}</p>
			</div>
		)
	});
	return(
		<div id='teachers-pagepicker'>
			{pages}
		</div>
	)
}


